import React from 'react';
import classNames from 'classnames';

export default function Badge({ src, icon = false, ...props }) {
  props.className = classNames('badge', icon ? 'badge-icon' : null, props.className);

  return <img {...props} src={src} />;
}
